window.initProductCarousel = function (wrapperId) {
  var wrapper = document.getElementById(wrapperId);
  if (!wrapper) return;

  var track = wrapper.querySelector('.product-carousel-track');
  var prevBtn = wrapper.querySelector('.product-carousel-arrow--prev');
  var nextBtn = wrapper.querySelector('.product-carousel-arrow--next');
  var dotsContainer = wrapper.parentElement.querySelector('.product-carousel-dots');
  var slides = Array.prototype.slice.call(track.querySelectorAll('.product-carousel-slide'));

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  if (dotsContainer && slides.length) {
    dotsContainer.innerHTML = '';
    slides.forEach(function (slide, i) {
      var dot = document.createElement('span');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', function () {
        var targetScroll = slide.offsetLeft - (track.clientWidth / 2) + (slide.clientWidth / 2);
        track.scrollTo({ left: targetScroll, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    });
  }

  function getClosestSlide() {
    var trackCenter = track.scrollLeft + track.clientWidth / 2;
    var closestSlide = slides[0];
    var closestDist = Infinity;
    slides.forEach(function (slide) {
      var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      var dist = Math.abs(slideCenter - trackCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closestSlide = slide;
      }
    });
    return closestSlide;
  }

  function snapToClosestSlide() {
    var closest = getClosestSlide();
    if (closest) {
      var targetScroll = closest.offsetLeft - (track.clientWidth / 2) + (closest.clientWidth / 2);
      track.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }
  }

  function updateActiveDot() {
    if (!dotsContainer) return;
    var trackCenter = track.scrollLeft + track.clientWidth / 2;
    var closestIndex = 0;
    var closestDist = Infinity;
    slides.forEach(function (slide, i) {
      var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      var dist = Math.abs(slideCenter - trackCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    });
    var dots = dotsContainer.querySelectorAll('.dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === closestIndex);
    });
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === closestIndex);
    });
  }

  function updateSlideScales() {
    if (isMobile()) return;

    var trackRect = track.getBoundingClientRect();
    var centerX = trackRect.left + trackRect.width / 2;
    var maxDistance = trackRect.width / 2;

    slides.forEach(function (slide) {
      var rect = slide.getBoundingClientRect();
      var slideCenter = rect.left + rect.width / 2;
      var distance = Math.abs(slideCenter - centerX);
      var ratio = Math.min(distance / maxDistance, 1);
      var scale = 1 - ratio * 0.4;
      var opacity = 1 - ratio * 0.4;
      slide.style.transform = 'scale(' + scale.toFixed(3) + ')';
      slide.style.opacity = opacity.toFixed(3);
    });
  }

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(updateSlideScales);
  });

  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveDot, 80);
  });

  var isScrolling = false;

  function scrollByAmount(direction) {
    if (isScrolling) return;
    isScrolling = true;

    var slideWidth = slides[0] ? slides[0].getBoundingClientRect().width + (isMobile() ? 0 : 24) : 260;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var tolerance = Math.max(20, slideWidth / 2); // generous buffer for padding/rounding

    var atEnd = direction > 0 && track.scrollLeft >= maxScroll - tolerance;
    var atStart = direction < 0 && track.scrollLeft <= tolerance;

    if (atEnd) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (atStart) {
      track.scrollTo({ left: maxScroll, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
    }

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      isScrolling = false;
      track.removeEventListener('scrollend', finish);
    }

    track.addEventListener('scrollend', finish);
    // fallback for browsers without scrollend support (e.g. older Safari)
    window.setTimeout(finish, 700);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

  wrapper.querySelectorAll('.product-carousel-add-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
    });
  });

  function centerMiddleSlide() {
    if (!slides.length || isMobile()) return;
    var middleIndex = Math.floor(slides.length / 2);
    var middleSlide = slides[middleIndex];
    var targetScroll = middleSlide.offsetLeft - (track.clientWidth / 2) + (middleSlide.clientWidth / 2);
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = targetScroll;
    updateActiveDot();
    updateSlideScales();
    window.setTimeout(function () {
      track.style.scrollBehavior = '';
    }, 50);
  }

  updateActiveDot();
  updateSlideScales();

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      centerMiddleSlide();
      window.setTimeout(function () {
        slides.forEach(function (slide) {
          slide.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
        });
      }, 100);
    });
  });

  window.addEventListener('load', centerMiddleSlide);

  var autoScrollTimer;

  function startAutoScroll() {
    stopAutoScroll();
    autoScrollTimer = window.setInterval(function () {
      scrollByAmount(1);
    }, 5000);
  }

  function stopAutoScroll() {
    if (autoScrollTimer) window.clearInterval(autoScrollTimer);
  }

  function handleTouchEnd() {
    startAutoScroll();
    if (isMobile() && !isScrolling) {
      window.setTimeout(snapToClosestSlide, 120);
    }
  }

  wrapper.addEventListener('mouseenter', stopAutoScroll);
  wrapper.addEventListener('mouseleave', startAutoScroll);
  track.addEventListener('touchstart', stopAutoScroll, { passive: true });
  track.addEventListener('touchend', handleTouchEnd, { passive: true });
  track.addEventListener('touchcancel', handleTouchEnd, { passive: true });

  startAutoScroll();
};
